module.exports = __webpack_public_path__ + "img/pic-6.714e321c.png";